import { createActions } from 'redux-actions';
import { create } from '../../services';

const {
  ifiLrrpCreateRequest,
  ifiLrrpCreateSuccess,
  ifiLrrpCreateFailure,
} = createActions({
  IFI_LRRP_CREATE_SUCCESS: json => json,
}, 'IFI_LRRP_CREATE_REQUEST', 'IFI_LRRP_CREATE_FAILURE');

export function ifiLrrpCreate(ifiLrrpData) {
  return (dispatch) => {
    dispatch(ifiLrrpCreateRequest());
    return create('ifi_lrrp', ifiLrrpData)
      .then(({ json }) => {
        dispatch(ifiLrrpCreateSuccess(json));
        return json;
      })
      .catch((error) => {
        dispatch(ifiLrrpCreateFailure(error));
        throw error;
      });
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/ifi_lrrps.js